<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Settings.ChangeOrganisation"></span>
        </h3>
    </div>

    <div class="p-4 pt-0">
        <div class="col-12">
            <label translate="Settings.Organisation"></label>
            <input type="text" id="organisationName" class="mt-2 form-control" [formControl]="searchOrganisationInput"
                (selectItem)="selectOrganisation($event)" [ngbTypeahead]="searchOrganisationFunction"
                popupClass="dropdown-menu-person-dialog" [resultTemplate]="resultTemplateOrganisations"
                autocomplete="off">
        </div>

        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()" translate="Button.Back"></button></span>
            <span class="float-end"><button type="submit" (click)="change()" [disabled]="selectedOrganisation && !selectedOrganisation.organisationGuid" class="btn btn-sm btn-primary" translate="Button.Change"></button></span>
        </div>
    </div>
</div>

<!--   SEARCH TEMPLATE, this is the field that drop downs for every instance-->
<ng-template #resultTemplateOrganisations let-r="result">
    {{r.organisationName}}<br />
    <div class="mt-1 information lh-sm">
        {{r.enterpriseName}}
    </div>
</ng-template>